// Which forms currently hold typing that hasn't been saved (IMP-064).
//
// The update flow (lib/appUpdate.ts) may reload the app on its own at the start
// of a session, and a reload discards whatever is on screen. So every form or
// free-text box that can hold unsaved input reports it here, and the update
// flow asks `hasUnsavedChanges()` before it reloads by itself, and before the
// Reload button discards anything (it asks first).
//
// Usage — one line in the component that owns the draft:
//
//   useUnsavedChanges(formState.isDirty);          // react-hook-form
//   useUnsavedChanges(draft.trim().length > 0);    // a comment box
//
// It is a count, not a flag, because two forms can be dirty at once (a page
// and a modal on top of it); each registration releases itself on unmount.

import { useEffect } from 'react';

let dirtyCount = 0;

/** True while any mounted form reports unsaved changes. */
export function hasUnsavedChanges(): boolean {
  return dirtyCount > 0;
}

/** Report this component's unsaved state for as long as it is mounted. */
export function useUnsavedChanges(dirty: boolean): void {
  useEffect(() => {
    if (!dirty) return undefined;
    dirtyCount += 1;
    return () => {
      dirtyCount -= 1;
    };
  }, [dirty]);
}
